<ion-header class="remove-margin-from-safe-area ion-no-border">
  <ion-toolbar >
    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-toolbar>
          <ion-buttons slot="end">
            <ion-button (click)="onCancelModal()" 
              ><ion-icon color="dark" name="close"></ion-icon
            ></ion-button>
          </ion-buttons>
        </ion-toolbar>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col style="text-align: center;">
          <h2 class="subheader-regular">{{ ('keys.data.menu.search' |
      translate : {Default:'Search'}) || 'Search' }}</h2>
        </ion-col>
      </ion-row>
    </ion-grid>
    
   
  </ion-toolbar>
</ion-header>
<ion-content>
 
    <ion-grid>
      <ion-row>
        <ion-col size="12">
          <ion-searchbar
            #searchInput
            placeholder="Search Plate or Ticket"
            [(ngModel)]="appealsSRV.searchText"
            debounce="250"
            (ionChange)="appealsSRV.onSearch()"
            style="--border-radius: 0.5em"
            inputmode="text"
            showCancelButton="focus"
            animated
          ></ion-searchbar>
        </ion-col>
      </ion-row>
      <ion-row *ngIf="appealsSRV.loadTickets==true">
        <ion-col>
          <ng-container *ngIf="appealsSRV.searchData">
            <ion-card
              class="ion-padding-top"
              *ngFor="let violation of appealsSRV.searchData['violations']"
            ><ion-grid>
              <ion-row>
                <ion-col>
                  <ion-item lines="none"
                  ><ion-label slot="start">{{violation.Ticket}}</ion-label
                  ><ion-badge  class="ion-text-wrap ion-text-right"
                    color="primary"
                    *ngIf="violation.appealType == appealsSRV.appealTypes.reduced"
                    >{{ ('keys.data.violations.reduced' | translate : {Default:'Reduced'} )
                    ||"Reduced"}}</ion-badge
                  >
                  <ion-badge class="ion-text-wrap ion-text-right"
                    color="success"
                    *ngIf="violation.appealType == appealsSRV.appealTypes.cancelled"
                    >{{ ('keys.data.violations.cancelled' | translate : {Default:'Cancelled'} )
                    ||"Cancelled"}}</ion-badge
                  >
                  <ion-badge class="ion-text-wrap ion-text-right"
                    color="danger"
                    *ngIf="violation.appealType == appealsSRV.appealTypes.denied"
                    >{{ ('keys.data.violations.upheld' | translate : {Default:'Upheld'} )
                    ||"Upheld"}}</ion-badge
                  ></ion-item
                >
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col>
                  <ion-item lines="none">
                    <ion-label slot="start"
                    >{{ ('keys.data.violations.issued' | translate : {Default:'Issued'} )
                    ||"Issued"}} </ion-label
                  >
                  <ion-label class="ion-text-wrap ion-text-right">
                    {{violation.Issued |
                      date:dataService.settings['system']['datemask']}}
                  </ion-label>
                  </ion-item>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col>
                  <ion-item lines="none">
                    <ion-label slot="start"
                    >{{ ('keys.data.violations.due' | translate : {Default:'Due'} ) ||"Due"}} </ion-label
                  >
                  <ion-label class="ion-text-wrap ion-text-right">
                    {{violation.Due |
                      date:dataService.settings['system']['datemask']}}
                  </ion-label>
                  </ion-item>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col>
                  <ion-button
                  (click)="appealsSRV.onAssociate(violation.VehicleID)"
                  expand="block"
                  color="primary"
                  *ngIf="violation.VehicleID"
                >
                {{ ('keys.data.vehicles.associate' |
                translate : {Default:'Associate'}) || 'Associate' }}
                </ion-button>
                <ion-button
                  expand="block"
                  fill="outline"
                  color="dark"
                  disabled
                  *ngIf="!violation.VehicleID"
                >
                {{ ('keys.data.vehicles.associate' |
                translate : {Default:'Associate'}) || 'Associate' }}
                </ion-button>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col>
                  <ion-item lines="none" style="text-align: center;">
                  <ion-label class="ion-text-wrap" *ngIf="violation.VehicleID">
                    {{
                    ('keys.data.violations.click_associate_to_link_to_vehicle' |
                    translate : {Default:"You are not associated to this vehicle. To
                    Appeal this violation click 'Associate' to add the vehicle
                    to your account."} ) ||"You are not associated to this vehicle. To
                    Appeal this violation click 'Associate' to add the vehicle
                    to your account."}}
                  </ion-label>
                  <ion-label class="ion-text-wrap" *ngIf="!violation.VehicleID">
                    {{
                    ('keys.data.violations.violation_associated_to_another_user'
                    | translate : {Default:'This violation is associated to another
                    user.'} ) ||"This violation is associated to another
                    user."}}
                  </ion-label>
                </ion-item>
                </ion-col>
              </ion-row>
            </ion-grid>
              
            </ion-card>
          </ng-container>
          <ion-row
            class="ion-padding-top"
            *ngIf="appealsSRV.searchData['violations'] && appealsSRV.searchData['violations'].length == 0"
          >
            <ion-col size="12">
              <ion-item lines="none">
              <ion-label>
                <ion-icon color="secondary"  style="
                  vertical-align: middle;
                  font-size: large;
                " name="information-circle"></ion-icon>
                  {{
                  ('keys.data.violations.could_not_find_violations_for_appeal' |
                  translate : {Default:'Could not find violations available for
                  appeal.'} ) ||"Could not find violations available for
                  appeal."}}
                </ion-label>
              </ion-item>
            </ion-col>
          </ion-row>
        </ion-col>
      </ion-row>
      <ion-row *ngIf="appealsSRV.loadTickets==false">
        <ion-col *ngFor="let x of [0, 1, 2, 3]" size="12">
          <ion-card>
            <ion-card-header style="text-align: center; font-weight: bold">
              <ion-title
                ><ion-skeleton-text
                  animated
                  style="width: 60%"
                ></ion-skeleton-text
              ></ion-title>
              <ion-card-subtitle
                ><ion-skeleton-text
                  animated
                  style="width: 60%"
                ></ion-skeleton-text
              ></ion-card-subtitle>
            </ion-card-header>
            <ion-card-content>
              <ion-row>
                <ion-col>
                  <ion-item>
                    <ion-skeleton-text
                      animated
                      style="width: 40%"
                    ></ion-skeleton-text>
                  </ion-item>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col>
                  <ion-item>
                    <ion-skeleton-text
                      animated
                      style="width: 40%"
                    ></ion-skeleton-text>
                  </ion-item>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col>
                  <ion-item>
                    <ion-skeleton-text
                      animated
                      style="width: 40%"
                    ></ion-skeleton-text>
                  </ion-item>
                </ion-col>
              </ion-row>
            </ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>
    </ion-grid>
  
</ion-content>
